import { render, staticRenderFns } from "./CloudFlareVerify.vue?vue&type=template&id=9ace2fd0"
import script from "./CloudFlareVerify.vue?vue&type=script&lang=js"
export * from "./CloudFlareVerify.vue?vue&type=script&lang=js"
import style0 from "./CloudFlareVerify.vue?vue&type=style&index=0&id=9ace2fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports